import { createContext, useContext, useState, type ReactNode } from 'react';

type SidebarContextType = {
    isMobileOpen: boolean;
    openMobileSidebar: () => void;
    closeMobileSidebar: () => void;
    toggleMobileSidebar: () => void;
};

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

type SidebarProviderProps = {
    children: ReactNode;
};

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    const openMobileSidebar = () => setIsMobileOpen(true);
    const closeMobileSidebar = () => setIsMobileOpen(false);
    const toggleMobileSidebar = () => setIsMobileOpen((prev) => !prev);

    const value: SidebarContextType = {
        isMobileOpen,
        openMobileSidebar,
        closeMobileSidebar,
        toggleMobileSidebar,
    };

    return (
        <SidebarContext.Provider value={value}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = (): SidebarContextType => {
    const context = useContext(SidebarContext);
    if (context === undefined) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};
